import { render, staticRenderFns } from "./GeneralSettingContactAddressPostcode.vue?vue&type=template&id=d7bfc170&"
import script from "./GeneralSettingContactAddressPostcode.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingContactAddressPostcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports